export const NOT_INPUT = 'が入力されていません。';
export const REQUIRED  = 'が不正です。';
export const INCORRECT  = 'が重複しています。';
export const SAVE_SUCCESS  = 'Lưu thành công';
export const UPDATE_SUCCESS  = 'Cập nhật thành công';
export const DELETE_SUCCESS  = 'Xóa thành công';
export const SYS_ERROR  = '内部エラーが発生しました。システム管理者に連絡してください。';